import React from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LibraryComponent from "../LibraryComponent/LibraryComponent";
import {getDisplayName} from "../../utils/utils";
import {MergeChildIcon, MergeBlueIcon, MergeParentOneIcon, MergeParentTwoIcon} from '../Icons/Icons'
import classes from './MergedPattern.module.css'
import {formatDate} from "../../utils/dateUtils";
import {useDispatch} from 'react-redux'
import * as actionTypes from "../../store/actions/actionTypes";
import InfoButton from "../IconButtons/InfoButton/InfoButton";

const style = {height: 20, marginBottom: 4, marginLeft: -8, marginRight: 2}
const styleIntext = {height: 20, marginInline: -4}

export default function MergedPatterns({mergedArr, patternName, selectPattern}) {
    const dispatch = useDispatch()

    function openUserProfile(userId) {
        dispatch({type: actionTypes.SELECT_USER, userId: userId});
        dispatch({type: actionTypes.OPEN_USER_MODAL});
    }

    function getIconAndText(item, patternName) {
        const displayName = getDisplayName(item.display_name, item.first_name, item.last_name)
        const hiddenPattern = 'Hidden Pattern'

        if (item.merge_parent_1_name !== undefined && item.merge_parent_2_name !== undefined) {
            const m1Item = item.merge_parent_1_name || hiddenPattern
            const m2Item = item.merge_parent_2_name || hiddenPattern

            return {
                icon: <MergeBlueIcon style={style}/>,
                    title: <div style={{textAlign: "center"}}>{`Merged ${m1Item} with ${m2Item}`}</div>,
                    popoverText: <div> This pattern was created by mering the patterns{' '}
                        <b className={classes.ThisPattern}>{m1Item}</b> and{' '}
                        <b className={classes.ThisPattern}>{m2Item}</b>.
                    </div>,
                text: (
                    <div>
                        The pattern{' '}
                        <b className={classes.Link} onClick={() => selectPattern(item.merge_parent_1)}>
                            <MergeParentOneIcon style={styleIntext} onClick={() => selectPattern(item.merge_parent_1)}/>{' '}
                            {m1Item}
                        </b>{' '}
                        was merged with{' '}
                        <b className={classes.Link} onClick={() => selectPattern(item.merge_parent_2)}>
                            <MergeParentTwoIcon style={styleIntext} onClick={() => selectPattern(item.merge_parent_2)}/>{' '}
                            {m2Item}
                        </b>{' '}
                        to create this pattern{' '}
                        <b className={classes.ThisPattern}>
                            <MergeChildIcon style={styleIntext}/>{' '}
                            {patternName}
                        </b>{' '}
                        on <span style={{color: "black"}}>{formatDate(item.timestamp, 'longDate')}</span> by{' '}
                        <b className={classes.Link} onClick={() => openUserProfile(item.user_id)}>{displayName}</b>.
                    </div>
                ),
                id: `${m1Item} with ${m2Item}`
            }
        } else if (item.merge_parent_1_name !== undefined && item.pattern_name !== undefined) {
            const m1Item = item.merge_parent_1_name || hiddenPattern
            const result = item.pattern_name || hiddenPattern

            return {
                icon: <MergeBlueIcon style={style}/>,
                title: <div style={{textAlign: "center"}}>{`Merged ${m1Item} with ${patternName}`}</div>,
                popoverText: <div> This pattern was merged with{' '}
                    <b className={classes.ThisPattern}>{m1Item}</b> to create the new pattern{' '}
                    <b className={classes.ThisPattern}>{result}</b>.
                </div>,
                text: (
                    <div>
                        The pattern{' '}
                        <b className={classes.Link} onClick={() => selectPattern(item.merge_parent_1)}>
                            <MergeParentOneIcon style={styleIntext} onClick={() => selectPattern(item.merge_parent_1)}/>{' '}
                            {m1Item}
                        </b>{' '}
                        was merged with this pattern{' '}
                        <b className={classes.ThisPattern}>
                            <MergeParentTwoIcon style={styleIntext}/>{' '}
                            {patternName}
                        </b>{' '}
                        to create the new pattern{' '}
                        <b className={classes.Link} onClick={() => selectPattern(item.pattern_id)}>
                            <MergeChildIcon style={styleIntext} onClick={() => selectPattern(item.pattern_id)}/>{' '}
                            {result}
                        </b>{' '}
                        on <span style={{color: "black"}}>{formatDate(item.timestamp, 'longDate')}</span> by{' '}
                        <b className={classes.Link} onClick={() => openUserProfile(item.user_id)}>{displayName}</b>.
                    </div>
                ),
                id: `${item.merge_parent_1} with ${item.pattern_id}`
            }
        } else if (item.merge_parent_2_name !== undefined) {
            const mp2Name = item.merge_parent_2_name || hiddenPattern;
            const result = item.pattern_name || hiddenPattern

            return {
                icon: <MergeBlueIcon style={style}/>,
                title: <div style={{textAlign: "center"}}>{`Merged ${patternName} with ${mp2Name}`}</div>,
                popoverText: <div> This pattern was merged with{' '}
                    <b className={classes.ThisPattern}>{mp2Name}</b> the new pattern{' '}
                    <b className={classes.ThisPattern}>{result}</b>.
                </div>,
                text: (
                    <div>
                        This pattern{' '}
                        <b className={classes.ThisPattern}>
                            <MergeParentOneIcon style={styleIntext}/>{' '}
                            {patternName}
                        </b>{' '}
                        was merged with{' '}
                        <b className={classes.Link} onClick={() => selectPattern(item.merge_parent_2)}>
                            <MergeParentTwoIcon style={styleIntext} onClick={() => selectPattern(item.merge_parent_2)}/>{' '}
                            {mp2Name}
                        </b>{' '}
                        to create the new pattern{' '}
                        <b className={classes.Link} onClick={() => selectPattern(item.pattern_id)}>
                            <MergeChildIcon style={styleIntext} onClick={() => selectPattern(item.pattern_id)}/>{' '}
                            {result}
                        </b>{' '}
                        on <span style={{color: "black"}}>{formatDate(item.timestamp, 'longDate')}</span> by{' '}
                        <b className={classes.Link} onClick={() => openUserProfile(item.user_id)}>{displayName}</b>.
                    </div>
                ),
                id: `${mp2Name} with ${item.pattern_id}`
            }
        } else {
            return {icon: <MergeBlueIcon/>, title: '', text: '', order: '', name: '', id: ''}
        }
    }

    const mergedValues = mergedArr.map((item) => {
        return getIconAndText(item, patternName)
    })

    return mergedArr && mergedArr.length > 0 &&
        <Row>
            <Col>
                <dl className="row" style={{marginBottom: "0px"}}>
                    <dt className="col-xl-2">Merge History:
                    <InfoButton infoContent={{
                        title: 'Merge History',
                        text: 'This pattern has been merged with, or was created by merging other patterns. ' +
                            'The details of these merges are shown in this section.'}}
                    />
                    </dt>
                    <dd className="col-xl-10">
                        <dl className={'suggested-exercises'}>
                            {mergedValues.map((merge, index) => {
                                return <LibraryComponent
                                    key={merge.id + index}
                                    name={'Merge ' + (index + 1)}
                                    uniqueId={merge.id}
                                    getIcon={() => {
                                        return merge.icon
                                    }}
                                    // comment back in to add a hover. If you do look over the text.
                                    // popoverText={{title: merge.title, text: merge.popoverText}}
                                    startDesc={''}
                                >
                                    <div className={classes.Container}>
                                        {merge.text}
                                    </div>
                                </LibraryComponent>
                            })}
                        </dl>
                    </dd>
                </dl>
            </Col>
        </Row>

}